import { axiosInstance as request } from '@api/rest.service'

const api = periodId => `/subscription-periods/${periodId}/subscription-period-items`

/**
 * @description GET /subscription-periods/{param}/subscription-period-items
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_PERIOD_ITEMS = periodId => request.get(api(periodId))

/**
 * @description POST /subscription-periods/{param}/subscription-period-items
 * @returns {AxiosPromise<any>}
 */
export const CREATE_SUBSCRIPTION_PERIOD_ITEM = (periodId, payload) => request.post(api(periodId), payload)

/**
 * @description PATCH /subscription-periods/{param}/subscription-period-items/{param}
 * @returns {AxiosPromise<any>}
 */
export const MODIFY_SUBSCRIPTION_PERIOD_ITEM = (periodId, itemId, payload) =>
  request.patch(api(periodId) + `/${itemId}`, payload)

/**
 * @description DELETE /subscription-periods/{param}/subscription-period-items/{param}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_SUBSCRIPTION_PERIOD_ITEM = (periodId, itemId) => request.delete(api(periodId) + `/${itemId}`)
